module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Light.04e33ef1.woff2";